export function getContainer(element: HTMLDialogElement | null) {
	if (!element) {
		return null
	}
	return element.querySelector(`[data-dialog-container]`) as HTMLElement
}
